import React from 'react';
import styled from 'styled-components';
import { IntroProps } from './utils';
import TrueImpactAnimation from '../../../design-system/base/TrueImpactAnimation';
import TrueImpactButton from '../../../design-system/components/TrueImpactButton';
import { SPACERS } from '../../../design-system/settings/variables/Spacers';
import TrueImpactText from '../../../design-system/base/TrueImpactText';
import TrueImpactBulletPoint from '../../../design-system/components/TrueImpactBulletPoint';
import eliminateImageSrc from 'shared/statics/welcome-eliminate-paperwork.png';

type IntroEliminateProps = IntroProps

const StyledDiv = styled.div`
  text-align: center;
  margin-top: ${SPACERS.large};
  padding-bottom: ${SPACERS.large};
  .eliminate-paperwork {
    margin-left: -30px;
    margin-bottom: -50px;
  }
  .eliminate-heading {
  }
  .eliminate-subheading {
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: ${SPACERS.large};
  }
  .eliminate-bullet-point-wrapper {
    display: inline-block;
    margin-bottom: ${SPACERS.extraLarge};
  }
`;

const IntroEliminate: React.FC<IntroEliminateProps> = ({ handleNextStep }) => {
  return (
    <TrueImpactAnimation variant="appear">
      <StyledDiv>
        <img
          src={eliminateImageSrc}
          title="eliminate-paperwork"
          alt="eliminate-paperwork"
          className="eliminate-paperwork"
        />
        <TrueImpactText variant="heading-page" className="eliminate-heading">
          Eliminate paperwork
        </TrueImpactText>
        <TrueImpactText variant="body-large" className="eliminate-subheading">
          Create a single “live” <strong>annual impact report</strong> that
          automatically updates all of your donors.
        </TrueImpactText>
        <div className="eliminate-bullet-point-wrapper">
          <div>
            <TrueImpactBulletPoint text="Start with a forecast." />
            <TrueImpactBulletPoint text="Add a mid-year update." />
            <TrueImpactBulletPoint text="Finish with end-of-year actual results." />
          </div>
        </div>
        <TrueImpactAnimation variant="pulse" animationDelay={10}>
          <TrueImpactButton onClick={handleNextStep}>Continue</TrueImpactButton>
        </TrueImpactAnimation>
      </StyledDiv>
    </TrueImpactAnimation>
  );
};

export default IntroEliminate;
